var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("profile-icon-container " + _vm.shape),style:({backgroundColor: _vm.backgroundColor, '--shape-size': _vm.size })},[_c('colored-svg',{attrs:{"color":_vm.whiteColor,"svg-src":_vm.shapePath}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }